var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "basic_image_material",
      staticStyle: { position: "relative" },
    },
    [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "title" }, [
          _c("svg", { staticClass: "icon", attrs: { "aria-hidden": "true" } }, [
            _c("use", { attrs: { "xlink:href": "#icon-haibaoxinxi16" } }),
          ]),
          _vm._v(
            " " +
              _vm._s(
                _vm.$route.query.channelType == "4" ? "二维码" : "用户头像22"
              ) +
              " "
          ),
        ]),
        _vm.$route.query.channelType == "4"
          ? _c(
              "div",
              {
                staticClass: "img codeImg",
                on: {
                  click: function ($event) {
                    return _vm.add_module(_vm.imgCodeData, "qrCode")
                  },
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: "https://preapiconsole.71360.com/w3/z28qxv/20230828/7a7d6ee51cdea786cc501d8e91db6477.jpeg?ct=webp",
                    alt: "",
                  },
                }),
                _c("div", { staticClass: "codehover" }, [
                  _vm._v(" 职位二维码 "),
                ]),
              ]
            )
          : _c(
              "div",
              {
                staticClass: "img",
                on: {
                  click: function ($event) {
                    return _vm.add_module(_vm.imgData, "userProfile")
                  },
                },
              },
              [_c("img", { attrs: { src: "/img/poster/avatar.svg", alt: "" } })]
            ),
      ]),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "title" }, [
            _c(
              "svg",
              { staticClass: "icon", attrs: { "aria-hidden": "true" } },
              [_c("use", { attrs: { "xlink:href": "#icon-haibaoxinxi16" } })]
            ),
            _vm._v(" 上传图片 "),
          ]),
          _c(
            "el-tooltip",
            {
              staticClass: "item",
              attrs: {
                content:
                  "图片大小不得超过5M，支持文件类型为png，jpg，jpeg，建议尺寸：750*1220px。",
                placement: "top-end",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "content",
                  staticStyle: { width: "300px" },
                  attrs: { slot: "content" },
                  slot: "content",
                },
                [
                  _vm._v(
                    "图片大小不得超过5M，支持文件类型为png，jpg，jpeg，图片长宽比为4:3，建议尺寸320px*240px。"
                  ),
                ]
              ),
              _c("Upload", {
                ref: "uploadRef",
                attrs: {
                  type: "img",
                  allowType: _vm.acceptType,
                  allowSize: 5 * 1024,
                  limit: 1,
                  showFileList: false,
                },
                on: { uploadSuccess: _vm.uploadSuccess },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.$store.state.widgets.replace_img_type === "pictures"
        ? _c(
            "el-button",
            {
              staticStyle: {
                "z-index": "9999",
                position: "absolute",
                left: "0",
                bottom: "10px",
                width: "100%",
              },
              attrs: { type: "primary" },
              on: { click: _vm.picturesConfirm },
            },
            [_vm._v(" 确定 ")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }